export default {

    root: {
        path: '/',
        get: () => '/'
    },
    search: {
        path: '/search',
        get: () => '/search'
    },
    about: {
        path: '/about',
        get: () => '/about'
    },
    locations: {
        path: '/locations',
        get: () => '/locations'
    },
    location: {
        path: '/locations/:slug',
        get: (slug) => `/locations/${slug}`
    },
    sharedBook: {
        path: '/private/:slug',
        get: (slug) => `/private/${slug}`
    },
    categoryList: {
        path: '/playbook',
        get: () => '/playbook'
    },
    category: {
        path: '/playbook/:slug',
        get: (slug) => `/playbook/${slug}`
    },
    article: {
        path: '/:slug',
        get: (parentSlug, slug) => `/${slug}`
    },
    articleamp: {
        path: '/amp-builder/:slug',
        get: (parentSlug, slug) => `/amp-builder/${slug}`
    },
    stores: {
        path: '/stores',
        get: () => '/stores'
    },
    store: {
        path: '/stores/:slug',
        get: (slug) => `/stores/${slug}`
    },
    onlineStore: {
        path: '/shop',
        get: () => '/shop'
    },
    product: {
        path: '/shop/:slug',
        get: (slug) => `/shop/${slug}`
    },
    form: {
        path: '/form/:slug',
        get: (slug) => `/form/${slug}`
    },
    formP: {
        path: '/formP/:slug',
        get: (slug) => `/formP/${slug}`
    },
    formPretty: {
        path: '/nominations/:slug',
        get: (slug) => `/form/${slug}`
    },
}
